import { Trans, useTranslation } from 'react-i18next';
import React, { ReactNode, useMemo } from 'react';
import cx, { clsx } from 'clsx';

import { IconRcArrowRight } from '@/assets/common';
import { Button } from '@/components';
import { useSwitch, useCommentEligibility } from '@/hooks';

import { CommentEligibilityModal, CommentEligibilities } from './components';
import { ChannelPicker } from '../ChannelPicker';
import style from './index.module.scss';

export const PostFooter = ({
  isLoading,
  disabled,
  onSubmit,
  showPaidEligibility,
  hideChannelPicker,
  slot,
  hiddenEligibilityFields,
  className,
  channelPickerDisabled,
}: {
  disabled?: boolean;
  isLoading?: boolean;
  onSubmit?(): void;
  showPaidEligibility?: boolean;
  hideChannelPicker?: boolean;
  channelPickerDisabled?: boolean;
  slot?: ReactNode;
  hiddenEligibilityFields?: string[];
  className?: string;
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div className={clsx(style.footer, className)}>
        {!hideChannelPicker ? <ChannelPicker disabled={channelPickerDisabled} /> : null}
        {showPaidEligibility ? (
          <div className={style.paidCommentEligiblity}>{t('PostFooter.1uq5j2m')}</div>
        ) : (
          <EditCommentEligiblities hiddenEligibilityFields={hiddenEligibilityFields} />
        )}
        {slot}
        <Button
          type="primary"
          className={cx(style.submitButton, disabled && style.disabledButton)}
          loading={isLoading}
          disabled={disabled}
          onClick={onSubmit}>
          {t('PostFooter.1hg3k')}
        </Button>
      </div>
    </>
  );
};

const EditCommentEligiblities = ({
  hiddenEligibilityFields,
}: {
  hiddenEligibilityFields?: string[];
}) => {
  const { t } = useTranslation();

  const [commentEligibility] = useCommentEligibility();
  const { on, turnOff, turnOn } = useSwitch();

  const validCommentEligibilitiesCount = useMemo(
    () => (commentEligibility ? Object.keys(commentEligibility).length : 1),
    [commentEligibility],
  );

  return (
    <>
      <div className={style.eligibility}>
        <span className={style.footerTitle}>{t('PostFooter.1aqbfdg')}</span>
        <div className={style.footerSelect} onClick={turnOn}>
          {validCommentEligibilitiesCount > 0 ? (
            <Trans i18nKey="PostFooter.restrict" count={validCommentEligibilitiesCount}>
              <span className={style.eligiCount}>{validCommentEligibilitiesCount}</span>
              restrictions
            </Trans>
          ) : (
            t('PostFooter.noRestrict')
          )}{' '}
          <IconRcArrowRight className={style.arrow} />
        </div>
      </div>
      {on ? (
        <CommentEligibilityModal on={on} turnOff={turnOff} hiddenFields={hiddenEligibilityFields} />
      ) : null}
    </>
  );
};

export { CommentEligibilityModal, CommentEligibilities };
